<template>
	<div class="wrapperBlock">
		<row align-items="flex-start" justify-content="space-between">
			<span class="subtext">Additional payment in invoice</span>
			<button @click="onAdditionalPayment" class="wrapperBlock_button">
				<svg-sprite width="18" height="18" icon-id="addItem"></svg-sprite>
				<span>Add additional payment</span>
			</button>
		</row>
		<div class="wrapperBlock_body mr-20">
			<main-table
					padding="0 0 10px"
					:flag="flag"
					:headers="getHeaders"
					:listItems="payments"
					@updateClickButton="onClickButton($event, flag)"
					@updateHandleTable="onHandleTable($event, flag)"
					:is-hide-header="false"
					:items-per-page-amount="10"
					:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
			></main-table>
		</div>
	</div>
</template>

<script>
import {
	additionalActiveHeader,
	additionalHeader,
} from "@/components/Accounting/CustomerInvoices/CustomerInvoicesCreate/defaultHeaders";

export default {
	name: "BlockAdditional",
	props: {
		flag: String,
		additionalPayments: Array,
		payments: Array
	},
	computed: {
		getActiveHeaders() {
			return additionalActiveHeader;
		},
		getHeaders() {
			return additionalHeader;
		}
	},
	methods: {
		onAdditionalPayment() {
			this.$emit('updateAdditionalPayment');
		},
		onClickButton({ key, item }, nameComponent) {
			this.$emit('updateEditInvoice', { key, item, nameComponent });
		},
		onHandleTable(key, nameComponent, isOld) {
			this.$emit('updateEditInvoice', { key, nameComponent, isOld });
		},
		onCheckbox({ value }, key) {
			this.$emit('updateCheckbox', { value, key });
		}
	}
};
</script>

<style scoped lang="scss">
@import "../blockStyles";
</style>
